import { render, staticRenderFns } from "./domain-coverage.vue?vue&type=template&id=4e3ac2ad&scoped=true"
import script from "./domain-coverage.vue?vue&type=script&lang=js"
export * from "./domain-coverage.vue?vue&type=script&lang=js"
import style0 from "./domain-coverage.vue?vue&type=style&index=0&id=4e3ac2ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ac2ad",
  null
  
)

export default component.exports